module.exports = __webpack_public_path__ + "static/download-cover-image-a1f7dd7acd1b5798ef8cff2fd7da3e6d.jpg";